import { useTranslation } from 'react-i18next'
import { createContext, useEffect, useState } from "react";

import KrabiSunsetImg1 from '../assets/Krabi Sunset Cruises/img1.jpg'
import KrabiSunsetImg2 from '../assets/Krabi Sunset Cruises/img2.jpg'
import KrabiSunsetImg3 from '../assets/Krabi Sunset Cruises/img3.jpg'
import KrabiSunsetImg4 from '../assets/Krabi Sunset Cruises/img4.jpg'

import SongPharekImg1 from '../assets/Song Phraek/img1.jpg'
import SongPharekImg2 from '../assets/Song Phraek/img2.jpg'
import SongPharekImg3 from '../assets/Song Phraek/img3.jpg'
import SongPharekImg4 from '../assets/Song Phraek/img4.jpg'

import BarracudasImg1 from '../assets/Barracudas/img1.jpg'
import BarracudasImg2 from '../assets/Barracudas/img2.jpg'
import BarracudasImg3 from '../assets/Barracudas/img3.jpg'
import BarracudasImg4 from '../assets/Barracudas/img4.jpg'

import JamesBondImg1 from '../assets/James Bond/img1.jpg'
import JamesBondImg2 from '../assets/James Bond/img2.jpg'
import JamesBondImg3 from '../assets/James Bond/img3.jpg'
import JamesBondImg4 from '../assets/James Bond/img4.jpg'

import ScubaSnorkelingImg1 from '../assets/Scuba diving/img1.jpg'
import ScubaSnorkelingImg2 from '../assets/Scuba diving/img2.jpg'
import ScubaSnorkelingImg3 from '../assets/Scuba diving/img3.jpg'
import ScubaSnorkelingImg4 from '../assets/Scuba diving/img4.jpg'

import AoThalaneImg1 from '../assets/Ao Thalane Kayaking/img2.jpg'
import AoThalaneImg2 from '../assets/Ao Thalane Kayaking/img1.jpg'
import AoThalaneImg3 from '../assets/Ao Thalane Kayaking/img3.jpg'
import AoThalaneImg4 from '../assets/Ao Thalane Kayaking/img4.jpg'

import PhiPhiImg1 from '../assets/Phi Phi Island/img1.jpg'
import PhiPhiImg2 from '../assets/Phi Phi Island/img2.jpg'
import PhiPhiImg3 from '../assets/Phi Phi Island/img3.jpg'
import PhiPhiImg4 from '../assets/Phi Phi Island/img4.jpg'

import ThaiCookeryImg1 from '../assets/Krabi Thai Cookery/img1.jpg'
import ThaiCookeryImg2 from '../assets/Krabi Thai Cookery/img2.jpg'
import ThaiCookeryImg3 from '../assets/Krabi Thai Cookery/img3.jpg'
import ThaiCookeryImg4 from '../assets/Krabi Thai Cookery/img4.jpg'

import ShootingImg1 from '../assets/Shooting Range/img1.jpg'
import ShootingImg2 from '../assets/Shooting Range/img2.jpg'
import ShootingImg3 from '../assets/Shooting Range/img3.jpg'
import ShootingImg4 from '../assets/Shooting Range/img4.jpg'

import JungleImg1 from '../assets/Jungle tour/img1.jpg'
import JungleImg2 from '../assets/Jungle tour/img2.jpg'
import JungleImg3 from '../assets/Jungle tour/img3.jpg'
import JungleImg4 from '../assets/Jungle tour/img4.jpg'

import SevenIslandsImg1 from '../assets/Seven islands/img1.jpg'
import SevenIslandsImg2 from '../assets/Seven islands/img2.jpg'
import SevenIslandsImg3 from '../assets/Seven islands/img3.jpg'
import SevenIslandsImg4 from '../assets/Seven islands/img4.jpg'

import ElephantCareImg1 from '../assets/Elephant care/img4.jpg'
import ElephantCareImg2 from '../assets/Elephant care/img2.jpg'
import ElephantCareImg3 from '../assets/Elephant care/img3.jpg'
import ElephantCareImg4 from '../assets/Elephant care/img1.jpg'

import KingClimbersImg1 from '../assets/King Climbers/img1.jpg'
import KingClimbersImg2 from '../assets/King Climbers/img2.jpg'
import KingClimbersImg3 from '../assets/King Climbers/img3.jpg'
import KingClimbersImg4 from '../assets/King Climbers/img4.jpg'

import KhaoSokImg1 from '../assets/Kao sok/img1.jpg'
import KhaoSokImg2 from '../assets/Kao sok/img2.jpg'
import KhaoSokImg3 from '../assets/Kao sok/img3.jpg'
import KhaoSokImg4 from '../assets/Kao sok/img4.jpg'

export const DContext = createContext()




export default function DataContext(props) {
  const { t } = useTranslation()
  const [ln, setLn] = useState('en')
  const [currency, setCurrency] = useState('thb')
  const [dbPackage, setDbPackage] = useState(null)
  const [packageData, setPackageData] = useState(null)

  const BeURL = process.env.REACT_APP_BeUrl
  const [isAuth, setIsAuth] = useState(null)
  const [currentUser, setCurrentUser] = useState(null)
  const [Loader, setLoader] = useState(false)


  const [renderDropdown, setRenderDropdown] = useState(null)

  const [activities, setActivities] = useState(null)
  const [destinations, setDestinations] = useState(null)
  const [filteredPackages, setFilteredPackages] = useState(null)
  const [activitySuggestions, setActivitySuggestions] = useState(null)
  const [packageTitleSuggestions, setPackageTitleSuggestions] = useState(null)
  const [searchPlaceholders, setSearchPlaceholders] = useState({
    destination: '',
    activity: '',
    package: ''
  })

  const [enteredDestination, setEnteredDestination] = useState('')
  const [enteredActivity, setEnteredActivity] = useState('')
  const [enteredText, setEnteredText] = useState('')

  const makeSlug = (value, fallbackId) => {
    const base = String(value || '')
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')

    if (base) return base
    return `package-${fallbackId || 'item'}`
  }

  const collectStrings = (...values) => {
    const collected = []

    values.forEach((value) => {
      if (Array.isArray(value)) {
        value.forEach((item) => {
          const text = String(item || '').trim()
          if (text) collected.push(text)
        })
      } else if (typeof value === 'string') {
        const text = value.trim()
        if (text) collected.push(text)
      }
    })

    return collected
  }

  const uniqueByLowercase = (items) => {
    const seen = new Set()
    const result = []

    items.forEach((item) => {
      const text = String(item || '').trim()
      if (!text) return
      const key = text.toLowerCase()
      if (seen.has(key)) return
      seen.add(key)
      result.push(text)
    })

    return result
  }

  // eslint-disable-next-line no-unused-vars
  const PackagesImg = [
    {
      package: "Krabi-Sunset-Cruises",
      images: [
        KrabiSunsetImg1,
        KrabiSunsetImg2,
        KrabiSunsetImg3,
        KrabiSunsetImg4,
      ],
    },
    {
      package: "Song-Phraek",
      images: [
        SongPharekImg1,
        SongPharekImg2,
        SongPharekImg3,
        SongPharekImg4,
      ],
    },
    {
      package: "Barracudas",
      images: [
        BarracudasImg1,
        BarracudasImg2,
        BarracudasImg3,
        BarracudasImg4,
      ],
    },
    {
      package: "James-Bond",
      images: [
        JamesBondImg1,
        JamesBondImg2,
        JamesBondImg3,
        JamesBondImg4,
      ],
    },
    {
      package: "Scuba-Diving",
      images: [
        ScubaSnorkelingImg1,
        ScubaSnorkelingImg2,
        ScubaSnorkelingImg3,
        ScubaSnorkelingImg4,
      ],
    },
    {
      package: "Ao-Thalane",
      images: [
        AoThalaneImg1,
        AoThalaneImg2,
        AoThalaneImg3,
        AoThalaneImg4,
      ],
    },
    {
      package: "Phi-Phi-Island",
      images: [
        PhiPhiImg1,
        PhiPhiImg2,
        PhiPhiImg3,
        PhiPhiImg4,
      ],
    },
    {
      package: "Krabi-Thai-Cookery",
      images: [
        ThaiCookeryImg1,
        ThaiCookeryImg2,
        ThaiCookeryImg3,
        ThaiCookeryImg4,
      ],
    },
    {
      package: "Shooting-Range",
      images: [
        ShootingImg1,
        ShootingImg2,
        ShootingImg3,
        ShootingImg4,
      ],
    },
    {
      package: "Jungle-Tour",
      images: [
        JungleImg1,
        JungleImg2,
        JungleImg3,
        JungleImg4,
      ],
    },
    {
      package: "Seven-Islands",
      images: [
        SevenIslandsImg1,
        SevenIslandsImg2,
        SevenIslandsImg3,
        SevenIslandsImg4,
      ],
    },
    {
      package: "Elephant-Care",
      images: [
        ElephantCareImg1,
        ElephantCareImg2,
        ElephantCareImg3,
        ElephantCareImg4,
      ],
    },
    {
      package: "King-Climbers",
      images: [
        KingClimbersImg1,
        KingClimbersImg2,
        KingClimbersImg3,
        KingClimbersImg4,
      ],
    },
    {
      package: "Khao-Sok",
      images: [
        KhaoSokImg1,
        KhaoSokImg2,
        KhaoSokImg3,
        KhaoSokImg4,
      ],
    },
  ];


  const tempPackages = Object.entries(t("packages", { returnObjects: true })).map(([key, value], index) => {
    return [key, { ...value, id: index + 1 }];
  })

  const packages = Object.fromEntries(tempPackages)

  console.log("packages in context:", packages)


  // eslint-disable-next-line no-unused-vars
  let packageArray = Object.values(packages).map((item, index) => ({ id: index + 1, ...item }))


  useEffect(() => {
    if (BeURL && t) {
      fetch(`${BeURL}/fetch-packages`)
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            const tempPAckages = data.packages
            console.log("tempPAckages:", tempPAckages)
            const priceHandler = {
              thb: {
                kid: 0,
                adult: 0
              },
              usd: {
                kid: 0,
                adult: 0
              }
            }
            const structuredPAckages = tempPAckages.map((item, i) => (
              {
                id: item.id,
                slug: item.slug || makeSlug(item?.title?.en, item.id),
                isPopular: item.isPopular || false,
                title: item.title,
                desc: item.description,
                activities: item.activities,
                activity: item.activities,
                inclusion: item.inclusion,
                whatToBring: item.whatToBring,
                destinations: item.destinations,
                img: item.images.map((img) => (
                  String(img || '').startsWith('http://') || String(img || '').startsWith('https://')
                    ? img
                    : `${BeURL}/${img}`
                )),
                path: item.slug || makeSlug(item?.title?.en, item.id),
                priceType: item.priceType,
                isHalfPrice: item.isHalfPrice,
                isLongTailPrice: item.isLongTailPrice,
                isEntranceFees: item.isEntranceFees,
                entranceFees: item.entranceFees || 0,
                price: item.price || priceHandler,
                halfPrice: item.halfPrice || priceHandler,
                speedBoatPrice: item.speedBoatPrice || priceHandler,
                longTailPrice: item.longTailPrice || priceHandler
              }
            ))
            setDbPackage(structuredPAckages)
          }
          else {
            alert(data.message)
          }
        })
        .catch(err => {
          console.log("Error in fetching packages:", err)
          alert("Trouble in connecting to the Server!")
        })
    }
  }, [BeURL, t])

  useEffect(() => {
    if (dbPackage && ln) {
      console.log("dbPackage:", dbPackage)
      const tempPrice = {
        thb: {
          kid: 0,
          adult: 0
        },
        usd: {
          kid: 0,
          adult: 0
        }
      }
      const tempPackageData = dbPackage.map(item => (
        {
          id: item.id,
          slug: item.slug,
          isPopular: item.isPopular || false,
          title: item.title[ln],
          desc: item.desc[ln],
          activities: item.activities[ln],
          activity: item.activities[ln],
          inclusion: item.inclusion[ln],
          whatToBring: item.whatToBring[ln],
          destinations: item.destinations[ln],
          img: item.img.map(img => (`${img}`)),
          path: item.slug || makeSlug(item?.title?.en, item.id),
          priceType: item.priceType,
          isHalfPrice: item.isHalfPrice,
          isLongTailPrice: item.isLongTailPrice,
          price: item.price || tempPrice,
          halfPrice: item.halfPrice || tempPrice,
          speedBoatPrice: item.speedBoatPrice || tempPrice,
          longTailPrice: item.longTailPrice || tempPrice,
          isEntranceFees: item.isEntranceFees,
          entranceFees: item.entranceFees || 0,
        }
      ))

      setPackageData(tempPackageData)
    }
  }, [dbPackage, ln])

  // {
  //   id: item.id,
  //   title: item.title[ln],
  //   desc: item.description[ln],
  //   activities: item.activities[ln],
  //   activity: item.activities[ln],
  //   inclusion: item.inclusion[ln],
  //   whatToBring: item.whatToBring[ln],
  //   destinations: item.destinations[ln],
  //   img: item.images.map(img=>(`${BeURL}/${img}`)),
  //   path: item.title[ln].replace(/\s+/g, '-').toLowerCase(),
  //   price: item.price,
  // }


  // useEffect(()=>{


  //   if(packages && Object.keys(packages).length > 0){
  //     packageArray = Object.values(packages)
  //     const tempArray = packageArray.map((item,index)=>{
  //       return {
  //         id: item.id,
  //         title: item.title,
  //         desc: item.description,
  //         activities: item.activities,
  //         activity: item.activity,
  //         inclusion: item.inclusion,
  //         whatToBring: item.whatToBring,
  //         destinations: item.destinations,
  //         img: PackagesImg[index].images,
  //         path: PackagesImg[index].package
  //       }
  //     })
  //     setPackageData(tempArray)
  //   }
  // },[t])


  useEffect(() => {
    if (packageData) {

      setFilteredPackages(packageData)
      const activitySet = new Set();

      packageData.forEach((item) => {
        item.activities?.forEach((activity) => {
          activitySet.add(activity);
        });
      });

      const uniqueActivities = Array.from(activitySet);
      setActivities(uniqueActivities);


      const destinationSet = new Set();

      packageData.forEach((item) => {
        item.destinations && item.destinations.forEach((destination) => {
          destinationSet.add(destination);
        });
      });

      const uniqueDestinations = Array.from(destinationSet);
      setDestinations(uniqueDestinations);

      const titleSuggestions = uniqueByLowercase(packageData.map((item) => item.title).filter(Boolean));
      setPackageTitleSuggestions(titleSuggestions);

      const activitySuggestionPool = packageData.flatMap((item) => collectStrings(
        item.title,
        item.desc,
        item.activities,
        item.inclusion
      ));
      setActivitySuggestions(uniqueByLowercase(activitySuggestionPool));

      const firstPackage = packageData[0] || {};
      const firstDestination = Array.isArray(firstPackage.destinations) ? firstPackage.destinations.find(Boolean) || '' : '';
      const firstActivity = Array.isArray(firstPackage.activities) ? firstPackage.activities.find(Boolean) || '' : '';
      const firstTitle = firstPackage.title || '';

      setSearchPlaceholders({
        destination: firstDestination,
        activity: firstActivity,
        package: firstTitle
      });
    }
  }, [packageData])


  const filterPackages = (keyword, method) => {
    const sourcePackages = Array.isArray(packageData) ? packageData : []

    if (keyword) {
      const normalizedKeyword = String(keyword).toLowerCase().trim()
      let tempPackages = []
      if (method === 'destination') {
        tempPackages = sourcePackages.filter(item => (
          Array.isArray(item.destinations)
          && item.destinations.some(destination => String(destination).toLowerCase().includes(normalizedKeyword))
        ))
      }
      else if (method === 'activity') {
        tempPackages = sourcePackages.filter(item => (
          Array.isArray(item.activities)
          && item.activities.some(activity => String(activity).toLowerCase().includes(normalizedKeyword))
        ))
      }
      else if (method === 'text') {
        tempPackages = sourcePackages.filter(packageItem => {
          const packageItemsValues = Object.values(packageItem);

          // Check if any value in the item matches the keyword
          return packageItemsValues.some(value => {
            if (typeof value === 'string') {
              // Direct string comparison
              return value.toLowerCase().includes(normalizedKeyword);
            } else if (Array.isArray(value)) {
              // Check arrays for matches
              return value.some(item =>
                typeof item === 'string' && item.toLowerCase().includes(normalizedKeyword)
              );
            } else if (typeof value === 'object' && value !== null) {
              // Check objects for matches
              return Object.values(value).some(innerValue =>
                typeof innerValue === 'string' && innerValue.toLowerCase().includes(normalizedKeyword)
              );
            }
            return false; // Default for unsupported types
          });
        });
      }
      else if (method === 'package') {
        tempPackages = sourcePackages.filter(packageItem => (
          String(packageItem.title || '').toLowerCase().includes(normalizedKeyword)
        ))
      }
      // else if(method==='text'){
      //   tempPackages = packageData.filter(packageItem =>{
      //     const packageItemsValues = Object.values(packageItem)
      //     const filteredItems = packageItemsValues.filter(packageKeywords=>{
      //       if(typeof packageKeywords === 'object'){
      //         const tempValues = Object.values(packageKeywords)
      //       }
      //       // if(typeof packageKeywords === 'object'){
      //       //   packageKeywords.forEach(data=>{
      //       //     if(data.toLowerCase().includes(keyword.toLowerCase())){
      //       //       return true
      //       //     }
      //       //   })
      //       // }
      //       // else if(typeof packageKeywords === 'string'){
      //       //   if(packageKeywords.toLowerCase().includes(keyword.toLowerCase())){
      //       //     return true
      //       //   }
      //       // }
      //       // else{
      //       // }
      //     })
      //   }
      //   )
      // }
      else if (method === 'all') {
        tempPackages = sourcePackages
      }
      else {
        tempPackages = sourcePackages
      }
      setFilteredPackages(tempPackages)
    }
    else {
      setFilteredPackages(sourcePackages)
    }
  }

  useEffect(() => {
    if (enteredDestination === '' && enteredActivity === '' && enteredText === '') {
      setFilteredPackages(Array.isArray(packageData) ? packageData : [])
    }
  }, [enteredDestination, enteredActivity, enteredText, packageData])








  // const packages = [
  //     {
  //       name: "BARRACUDAS",
  //       destination: "PHI PHI ISLAND, 4 ISLAND, HONG ISLAND",
  //       activity: "BOAT CRUZE, SNORKELING",
  //       description: "Explore the stunning islands of Krabi with this exciting package, featuring boat cruises and snorkeling adventures in crystal-clear waters.",
  //       path: "barracudas",
  //       img: Barracudas
  //     },
  //     {
  //       name: "JAMES BOND",
  //       destination: "PANYEE VILLAGE, MONKEY CAVE",
  //       activity: "CANOEING",
  //       description: "Visit iconic locations featured in the James Bond movies while enjoying a serene canoeing experience through beautiful landscapes.",
  //       path: "james-bond",
  //       img: Jamesbond
  //     },
  //     {
  //       name: "KRABI SUN SET",
  //       destination: "PHI PHI ISLAND, 7 ISLAND, HONG ISLAND, RAILAY SUN SET, MONKEY BEACH, VIKING CAVE, BAMBOO ISLAND, TANG MING, PODA ISLAND, BIOLUMINESCENT, PLANKTON, PILEHBEY",
  //       activity: "BOAT CRUZE, SNORKELING",
  //       description: "Discover the magic of Krabi with a sunset tour that includes snorkeling, bioluminescent plankton, and breathtaking views of the Andaman Sea.",
  //       path: "krabi-sunset",
  //       img: KrabiSunset
  //     },
  //     {
  //       name: "KRABI SUNSET CURIES",
  //       destination: "RAILAY BEACH, PHI PHI ISLAND, BAMBOO ISLAND, PILEH LAGOON",
  //       activity: "BOAT CRUZE, SNORKELING, SWIMMING",
  //       description: "Enjoy a curated sunset tour with stops at Railay Beach and Phi Phi Island, perfect for swimming, snorkeling, and relaxing.",
  //       path: "krabi-sunset-curies",
  //       img: KrabiSunsetCurries
  //     },
  //     {
  //       name: "Ao Thalane Kayaking and Adventure Tours",
  //       destination: "Kayak through Ao Thalane's mangrove forest, Crocodile Cave, and scenic canyons.",
  //       activity: "Elephant trekking, ATV ride",
  //       description: "Paddle through lush mangroves, explore Crocodile Cave, and embark on thrilling adventures like elephant trekking and ATV rides.",
  //       path: "ao-thalane",
  //       img: AoThalane
  //     },
  //     {
  //       name: "King Climbers Rock Climbing Adventures",
  //       destination: "Railay Beach, Khao Luk Choee Cave",
  //       activity: "Rappelling, Abseiling, Multi-pitch climbing",
  //       description: "Challenge yourself with exhilarating rock climbing adventures on the stunning cliffs of Railay Beach.",
  //       path: "king-climbers",
  //       img: RockClimber
  //     },
  //     {
  //       name: "Khao Sok National Park Lake Tours by Grand South Travel",
  //       destination: "Guilin, Chiewlarn Lake, Tropical Rainforest, Diamond Cave",
  //       activity: "Wildlife safari, Sightseeing, Boat Cruze, Sunbathing, Relaxing",
  //       description: "Immerse yourself in the beauty of Khao Sok National Park with serene lake tours, wildlife safaris, and tranquil relaxation spots.",
  //       path: "khao-sok",
  //       img: Khaosok
  //     },
  //     {
  //       name: "Song Phraek Hosanna Rafture Adventure",
  //       destination: "Monkey Cave",
  //       activity: "Zipline Adventure, Jungle Walk, Canoeing, White Water Rafting, ATV Ride in the Jungle",
  //       description: "Get your adrenaline pumping with white-water rafting, zipline adventures, and ATV rides in the heart of Krabi’s jungles.",
  //       path: "song-phraek",
  //       img: SongPharaek
  //     },
  //     {
  //       name: "Scuba Diving and Snorkeling Trips & Courses",
  //       destination: "Ao Nang Islands & Phi Phi Islands",
  //       activity: "Scuba Diving, Snorkeling",
  //       description: "Dive into the underwater world with professional scuba diving and snorkeling trips at the Ao Nang and Phi Phi Islands.",
  //       path: "scuba-diving",
  //       img: Scuba
  //     },
  //     {
  //       name: "Phi Phi Islands Sunset & Plankton Tour",
  //       destination: "Phi Phi Islands, Maya Bay, Pi Leh Bay, Bamboo Island in Ao Nang, Monkey Beach, Ko Ma Tang Ming, Ko Poda Island",
  //       activity: "Swimming, Jumping",
  //       description: "Witness the enchanting sunset at Phi Phi Islands and swim among glowing plankton in the serene waters.",
  //       path: "phi-phi-sunset",
  //       img: Phiphi
  //     },
  //     {
  //       name: "Krabi Thai Cookery School & Home Restaurant by Ya",
  //       destination: "Ao Nang",
  //       activity: "Cooking",
  //       description: "Learn the secrets of authentic Thai cuisine with hands-on cooking classes led by local experts in Ao Nang.",
  //       path: "krabi-thai-cookery",
  //       img: Cookery
  //     },
  //     {
  //       name: "Shooting Range Packages",
  //       destination: "-",
  //       activity: "Shooting",
  //       description: "Test your aim with professional shooting range packages designed for all skill levels.",
  //       path: "shooting-range",
  //       img: Shooting
  //     },
  //     {
  //       name: "Jungle Tour Packages: Half-Day & Full-Day Options",
  //       destination: "Emerald Pool & Hot Spring Waterfall, Tiger Cave Temple",
  //       activity: "Swimming, Elephant Ride, Bathing with Elephants, ATV Ride",
  //       description: "Explore Krabi's lush jungles with guided tours that include hot springs, elephant rides, and adventurous ATV trails.",
  //       path: "jungle-tour",
  //       img: Jungle
  //     },
  //     {
  //       name: "7 Islands Sunset",
  //       destination: "Phra Nang Cave, Railay Bay, Chicken Island, Tup Island, Poda Island, Tang Ming Island, Pakbia Island, Lao Lading Island",
  //       activity: "Swimming, Snorkelling",
  //       description: "Capture the beauty of Krabi’s coastline with a tour of seven islands, featuring sunset views and snorkeling opportunities.",
  //       path: "seven-islands",
  //       img: SevenIsland
  //     },
  //     {
  //       name: "Elephant Care House Tour Programs (No Riding)",
  //       destination: "Tiger Cave Temple, Elephant Care House",
  //       activity: "Jungle Walks, Mud Bathing, Feeding",
  //       description: "Experience ethical elephant care with jungle walks, mud bathing, and feeding activities in a peaceful setting.",
  //       path: "elephant-care",
  //       img: TigerCave
  //     },
  //     {
  //       title: t("packages.phi_phi_sunset_bioluminescent_tour.title"),
  //       description: t("packages.phi_phi_sunset_bioluminescent_tour.description"),
  //       activities: [
  //         t("packages.phi_phi_sunset_bioluminescent_tour.activities.swimming"),
  //         t("packages.phi_phi_sunset_bioluminescent_tour.activities.jumping")
  //       ],
  //       inclusion: [
  //         t("packages.phi_phi_sunset_bioluminescent_tour.inclusion.hotelTransfer"),
  //         t("packages.phi_phi_sunset_bioluminescent_tour.inclusion.snorkelingEquipment"),
  //         t("packages.phi_phi_sunset_bioluminescent_tour.inclusion.lifeJackets"),
  //         t("packages.phi_phi_sunset_bioluminescent_tour.inclusion.lunchBox"),
  //         t("packages.phi_phi_sunset_bioluminescent_tour.inclusion.bbqDinner"),
  //         t("packages.phi_phi_sunset_bioluminescent_tour.inclusion.freshFruitsAndWater"),
  //         t("packages.phi_phi_sunset_bioluminescent_tour.inclusion.englishSpeakingGuide"),
  //         t("packages.phi_phi_sunset_bioluminescent_tour.inclusion.insurance")
  //       ],
  //       whatToBring: [
  //         t("packages.phi_phi_sunset_bioluminescent_tour.whatToBring.towel"),
  //         t("packages.phi_phi_sunset_bioluminescent_tour.whatToBring.swimwear"),
  //         t("packages.phi_phi_sunset_bioluminescent_tour.whatToBring.waterproofPhonePouch"),
  //         t("packages.phi_phi_sunset_bioluminescent_tour.whatToBring.changeOfClothes"),
  //         t("packages.phi_phi_sunset_bioluminescent_tour.whatToBring.flipFlops"),
  //         t("packages.phi_phi_sunset_bioluminescent_tour.whatToBring.sunscreen"),
  //         t("packages.phi_phi_sunset_bioluminescent_tour.whatToBring.camera")
  //       ],
  //       destinations: [
  //         t("packages.phi_phi_sunset_bioluminescent_tour.destinations.phiPhiIslands"),
  //         t("packages.phi_phi_sunset_bioluminescent_tour.destinations.mayaBay"),
  //         t("packages.phi_phi_sunset_bioluminescent_tour.destinations.piLehBay"),
  //         t("packages.phi_phi_sunset_bioluminescent_tour.destinations.bambooIsland"),
  //         t("packages.phi_phi_sunset_bioluminescent_tour.destinations.monkeyBeach"),
  //         t("packages.phi_phi_sunset_bioluminescent_tour.destinations.koMaTangMing"),
  //         t("packages.phi_phi_sunset_bioluminescent_tour.destinations.koPodaIsland")
  //       ]
  //     },
  //     {
  //       title: t("packages.krabi_thai_cookery_school.title"),
  //       description: t("packages.krabi_thai_cookery_school.description"),
  //       activities: [
  //         t("packages.krabi_thai_cookery_school.activities.cooking")
  //       ],
  //       inclusion: [
  //         t("packages.krabi_thai_cookery_school.inclusion.cookingClass"),
  //         t("packages.krabi_thai_cookery_school.inclusion.allIngredientsAndUtensils"),
  //         t("packages.krabi_thai_cookery_school.inclusion.recipeBooklet"),
  //         t("packages.krabi_thai_cookery_school.inclusion.hotelTransfers"),
  //         t("packages.krabi_thai_cookery_school.inclusion.welcomeDrinkAndSnacks"),
  //         t("packages.krabi_thai_cookery_school.inclusion.personalizedGuidance"),
  //         t("packages.krabi_thai_cookery_school.inclusion.certificateOfCompletion")
  //       ],
  //       whatToBring: [
  //         t("packages.krabi_thai_cookery_school.whatToBring.comfortableClothing"),
  //         t("packages.krabi_thai_cookery_school.whatToBring.closedToeShoes"),
  //         t("packages.krabi_thai_cookery_school.whatToBring.notebookAndPen"),
  //         t("packages.krabi_thai_cookery_school.whatToBring.camera"),
  //         t("packages.krabi_thai_cookery_school.whatToBring.reusableBag")
  //       ],
  //       destinations: [t("packages.krabi_thai_cookery_school.destinations.aoNang")]
  //     },
  //     {
  //       title: t("packages.shooting_range.title"),
  //       description: t("packages.shooting_range.description"),
  //       activities: [
  //         t("packages.shooting_range.activities.shooting")
  //       ],
  //       inclusion: [
  //         t("packages.shooting_range.inclusion.safetyBriefing"),
  //         t("packages.shooting_range.inclusion.selectionOfFirearms"),
  //         t("packages.shooting_range.inclusion.safetyEquipment"),
  //         t("packages.shooting_range.inclusion.targetSheets"),
  //         t("packages.shooting_range.inclusion.instructorAssistance"),
  //         t("packages.shooting_range.inclusion.hotelTransfers")
  //       ],
  //       whatToBring: [
  //         t("packages.shooting_range.whatToBring.validID"),
  //         t("packages.shooting_range.whatToBring.comfortableClothing"),
  //         t("packages.shooting_range.whatToBring.waterBottle"),
  //         t("packages.shooting_range.whatToBring.camera"),
  //         t("packages.shooting_range.whatToBring.excitemenAndFocus")
  //       ],
  //       destinations: [t("packages.shooting_range.destinations.aoNang")]
  //     },
  //     {
  //       title: t("packages.jungle_tour.title"),
  //       description: t("packages.jungle_tour.description"),
  //       activities: [
  //         t("packages.jungle_tour.activities.swimming"),
  //         t("packages.jungle_tour.activities.elephantRide"),
  //         t("packages.jungle_tour.activities.bathingWithElephants"),
  //         t("packages.jungle_tour.activities.atvRide")
  //       ],
  //       inclusion: [
  //         t("packages.jungle_tour.inclusion.hotelTransfers"),
  //         t("packages.jungle_tour.inclusion.drinkingWater"),
  //         t("packages.jungle_tour.inclusion.lunch"),
  //         t("packages.jungle_tour.inclusion.entranceFees"),
  //         t("packages.jungle_tour.inclusion.experiencedGuide"),
  //         t("packages.jungle_tour.inclusion.insurance")
  //       ],
  //       whatToBring: [
  //         t("packages.jungle_tour.whatToBring.sturdyShoes"),
  //         t("packages.jungle_tour.whatToBring.swimwearAndTowel"),
  //         t("packages.jungle_tour.whatToBring.sunblockAndRepellent"),
  //         t("packages.jungle_tour.whatToBring.reusableWaterBottle"),
  //         t("packages.jungle_tour.whatToBring.camera"),
  //         t("packages.jungle_tour.whatToBring.cashForExpenses")
  //       ],
  //       destinations: [
  //         t("packages.jungle_tour.destinations.emeraldPool"),
  //         t("packages.jungle_tour.destinations.hotSpringWaterfall"),
  //         t("packages.jungle_tour.destinations.tigerCaveTemple")
  //       ]
  //     },
  //     {
  //       title: t("packages.seven_islands_sunset.title"),
  //       description: t("packages.seven_islands_sunset.description"),
  //       activities: [
  //         t("packages.seven_islands_sunset.activities.swimming"),
  //         t("packages.seven_islands_sunset.activities.snorkeling")
  //       ],
  //       inclusion: [
  //         t("packages.seven_islands_sunset.inclusion.hotelTransfers"),
  //         t("packages.seven_islands_sunset.inclusion.freshFruitsAndSnacks"),
  //         t("packages.seven_islands_sunset.inclusion.halalMiniBuffetBBQ"),
  //         t("packages.seven_islands_sunset.inclusion.snorkelingGear"),
  //         t("packages.seven_islands_sunset.inclusion.travelInsurance"),
  //         t("packages.seven_islands_sunset.inclusion.englishSpeakingGuide")
  //       ],
  //       whatToBring: [
  //         t("packages.seven_islands_sunset.whatToBring.camera"),
  //         t("packages.seven_islands_sunset.whatToBring.sunscreen"),
  //         t("packages.seven_islands_sunset.whatToBring.towel"),
  //         t("packages.seven_islands_sunset.whatToBring.swimwear")
  //       ],
  //       destinations: [
  //         t("packages.seven_islands_sunset.destinations.phraNangCave"),
  //         t("packages.seven_islands_sunset.destinations.railayBay"),
  //         t("packages.seven_islands_sunset.destinations.chickenIsland"),
  //         t("packages.seven_islands_sunset.destinations.tupIsland"),
  //         t("packages.seven_islands_sunset.destinations.podaIsland"),
  //         t("packages.seven_islands_sunset.destinations.tangMingIsland"),
  //         t("packages.seven_islands_sunset.destinations.pakbiaIsland"),
  //         t("packages.seven_islands_sunset.destinations.laoLadingIsland")
  //       ]
  //     },
  //     {
  //       title: t("packages.elephant_care_house_tour.title"),
  //       description: t("packages.elephant_care_house_tour.description"),
  //       activities: [
  //         t("packages.elephant_care_house_tour.activities.jungleWalks"),
  //         t("packages.elephant_care_house_tour.activities.mudBathing"),
  //         t("packages.elephant_care_house_tour.activities.feeding")
  //       ],
  //       inclusion: [
  //         t("packages.elephant_care_house_tour.inclusion.hotelTransfer"),
  //         t("packages.elephant_care_house_tour.inclusion.drinkingWater"),
  //         t("packages.elephant_care_house_tour.inclusion.fruit"),
  //         t("packages.elephant_care_house_tour.inclusion.foodForFeeding")
  //       ],
  //       whatToBring: [
  //         t("packages.elephant_care_house_tour.whatToBring.comfortableShoes"),
  //         t("packages.elephant_care_house_tour.whatToBring.sunscreen"),
  //         t("packages.elephant_care_house_tour.whatToBring.camera"),
  //         t("packages.elephant_care_house_tour.whatToBring.clothingForDirt")
  //       ],
  //       destinations: [
  //         t("packages.elephant_care_house_tour.destinations.tigerCaveTemple"),
  //         t("packages.elephant_care_house_tour.destinations.elephantCareHouse")
  //       ]
  //     },
  //     {
  //       title: t("packages.king_climbers_rock_climbing.title"),
  //       description: t("packages.king_climbers_rock_climbing.description"),
  //       activities: [
  //         t("packages.king_climbers_rock_climbing.activities.rappelling"),
  //         t("packages.king_climbers_rock_climbing.activities.abseiling"),
  //         t("packages.king_climbers_rock_climbing.activities.multiPitchClimbing")
  //       ],
  //       inclusion: [
  //         t("packages.king_climbers_rock_climbing.inclusion.freeHotelPickUp"),
  //         t("packages.king_climbers_rock_climbing.inclusion.boatTransfer"),
  //         t("packages.king_climbers_rock_climbing.inclusion.drinkingWater")
  //       ],
  //       whatToBring: [
  //         t("packages.king_climbers_rock_climbing.whatToBring.climbingClothing"),
  //         t("packages.king_climbers_rock_climbing.whatToBring.climbingShoes"),
  //         t("packages.king_climbers_rock_climbing.whatToBring.sunscreen"),
  //         t("packages.king_climbers_rock_climbing.whatToBring.sunProtectionHat"),
  //         t("packages.king_climbers_rock_climbing.whatToBring.reusableWaterBottle"),
  //         t("packages.king_climbers_rock_climbing.whatToBring.camera")
  //       ],
  //       destinations: [
  //         t("packages.king_climbers_rock_climbing.destinations.railayBeach"),
  //         t("packages.king_climbers_rock_climbing.destinations.khaoLukChoeeCave")
  //       ]
  //     },
  //     {
  //       title: t("packages.khao_sok_lake_tours.title"),
  //       description: t("packages.khao_sok_lake_tours.description"),
  //       activities: [
  //         t("packages.khao_sok_lake_tours.activities.wildlifeSafari"),
  //         t("packages.khao_sok_lake_tours.activities.sightseeing"),
  //         t("packages.khao_sok_lake_tours.activities.boatCruise"),
  //         t("packages.khao_sok_lake_tours.activities.sunbathing"),
  //         t("packages.khao_sok_lake_tours.activities.relaxing")
  //       ],
  //       inclusion: [
  //         t("packages.khao_sok_lake_tours.inclusion.hotelTransfer"),
  //         t("packages.khao_sok_lake_tours.inclusion.travelInsurance"),
  //         t("packages.khao_sok_lake_tours.inclusion.nationalParkFees"),
  //         t("packages.khao_sok_lake_tours.inclusion.accommodation"),
  //         t("packages.khao_sok_lake_tours.inclusion.guide"),
  //         t("packages.khao_sok_lake_tours.inclusion.refreshments")
  //       ],
  //       whatToBring: [
  //         t("packages.khao_sok_lake_tours.whatToBring.clothingAndShoes"),
  //         t("packages.khao_sok_lake_tours.whatToBring.swimwearAndTowel"),
  //         t("packages.khao_sok_lake_tours.whatToBring.sunscreenAndRepellent"),
  //         t("packages.khao_sok_lake_tours.whatToBring.reusableWaterBottle"),
  //         t("packages.khao_sok_lake_tours.whatToBring.camera")
  //       ],
  //       destinations: [
  //         t("packages.khao_sok_lake_tours.destinations.cheowLanLake"),
  //         t("packages.khao_sok_lake_tours.destinations.khaoSokNationalPark")
  //       ]
  //     }
  // ];


  const [cart, setCart] = useState([])





  useEffect(() => {
    if (BeURL) {
      fetch(`${BeURL}/checkauth`, {
        credentials: "include"
      })
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            setIsAuth(true)
            setCurrentUser(data.user)
          }
          else {
            setIsAuth(false)
            setCurrentUser({})
          }
        })
        .catch(err => {
          setIsAuth(null)
          setCurrentUser(null)
          console.log("Erron in fetching User:", err)
          alert("Trouble in connecting to the Server, please try again later.")
        })
    }
  }, [BeURL])

  const handleLogout = () => {
    fetch(`${BeURL}/logout`, {
      credentials: "include"
    })
      .then(res => res.json())
      .then(data => {
        alert(data.message)
        if (data.success) {
          setIsAuth(false)
          setCurrentUser({})
          window.location.href = "/"
        }
      })
      .catch(err => {
        console.log("Erron in Logout:", err)
        alert("Trouble in connecting to the Server, please try again later.")
      })
  }


  const validateEmail = (enteredText) => {
    let Error
    if (!enteredText.trim()) {
      Error = 'This field is required.'
    }
    else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(enteredText.trim())) {
      Error = 'Invalid email format.'
    }
    return Error
  }

  const validatePassword = (enteredText) => {
    let Error;

    // Trim the password input
    const password = enteredText.trim();

    if (!password) {
      Error = 'Password is required.';
    }
    else {

      // Array to hold multiple error messages, if needed
      let passwordErrors = [];

      // Check minimum length
      if (password.length < 8) {
        passwordErrors.push('Password must be at least 8 characters long.');
      }

      // Check for at least one uppercase letter
      if (!/[A-Z]/.test(password)) {
        passwordErrors.push('Password must include at least one uppercase letter.');
      }

      // Check for at least one lowercase letter
      if (!/[a-z]/.test(password)) {
        passwordErrors.push('Password must include at least one lowercase letter.');
      }

      // Check for at least one numeric digit
      if (!/\d/.test(password)) {
        passwordErrors.push('Password must include at least one numeric digit.');
      }

      // Check for at least one special character (you can adjust the allowed set as needed)
      if (!/[!@#$%^&*]/.test(password)) {
        passwordErrors.push('Password must include at least one special character (e.g., !@#$%^&*).');
      }


      // If any of the password conditions failed, join them into one error message
      if (passwordErrors.length > 0) {
        Error = passwordErrors.join(' ');
      }
    }
    // Now Error will either be undefined (if no errors) or a string containing the error(s)

    return Error

  }



  const data = {
    packages: packageData,
    ln,
    setLn,
    activities,
    destinations,
    activitySuggestions,
    packageTitleSuggestions,
    searchPlaceholders,
    filteredPackages,
    filterPackages,
    renderDropdown,
    setRenderDropdown,
    enteredDestination,
    setEnteredDestination,
    enteredActivity,
    setEnteredActivity,
    enteredText,
    setEnteredText,
    cart,
    setCart,
    BeURL,
    handleLogout,
    isAuth,
    currentUser,
    setCurrentUser,
    setIsAuth,
    Loader,
    setLoader,
    validateEmail,
    validatePassword,
    currency,
    setCurrency
  }



  return (
    <DContext.Provider value={data}>
      {props.children}
    </DContext.Provider>
  )
}
